<template>
  <Crm />
</template>

<script>
import Crm from '../../components/adminCrm/Crm.vue'
export default {
  components: {
    Crm,
  },
}
</script>